import styled from 'styled-components'

export const StepperContainer = styled.div`
  align-self: center;
  width: 50%;
`
